import { createSelector } from "reselect"
import { get } from "lodash"
import { getIsOpPro } from "modules/account-root/selectors"
import { computeResourcePermissionsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"
import { getFullResourceType } from "modules/resources/helpers"

const EMPTY_ARRAY = []

export const getResourceType = (_, props) => getFullResourceType(props.params.resourceType)
export const getResourceId = (_, props) => get(props, "resourceMembers.resource.id")
export const getResourceMembers = (_, props) => get(props, "resourceMembers.resource.members", EMPTY_ARRAY)
export const getAccountMembers = (_, props) => get(props, "accountMembers.members", EMPTY_ARRAY)
export const getPermissionLevel = (_, props) => get(props, "resourceMembers.resource.permissionLevel")

export const getTabs = createSelector(
  [getRoute, getPath, getResourceType, getIsOpPro],
  computeResourcePermissionsTabs,
)
